import { render, staticRenderFns } from "./NurseProfileDetail.vue?vue&type=template&id=5ed55c4c&"
import script from "./NurseProfileDetail.vue?vue&type=script&lang=js&"
export * from "./NurseProfileDetail.vue?vue&type=script&lang=js&"
import style0 from "./NurseProfileDetail.vue?vue&type=style&index=0&id=5ed55c4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports